import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Service from "./pages/Service";
import Booking from "./pages/Booking";
import Login from "./pages/Login";
import Provider from "./pages/Provider";

function App() {
  return (
    <BrowserRouter>
      <div className="bg-black min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/service/:name" element={<Service />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/login" element={<Login />} />
          <Route path="/provider" element={<Provider />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
